// First Created - 29 Apr 2026
// Author - Atul Pandey

import {
    createSelector,
    createEntityAdapter,
} from '@reduxjs/toolkit'
import { apiSlice } from '@/app/api/apiSlice'

const userOrgBUMapsAdapter = createEntityAdapter({})

const initialState = userOrgBUMapsAdapter.getInitialState()

export const userOrgBUMapsApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({

        getUserOrgBUMaps: builder.query({
            query: (params) => ({
                url: '/userOrgBUMaps/getUserOrgBUMaps',
                params,
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                }
            }),
            transformResponse: responseData => {
                const loaded = responseData.map(item => {
                    item.id = item._id
                    return item
                })
                return userOrgBUMapsAdapter.setAll(initialState, loaded)
            },
            providesTags: (result) => {
                if (result?.ids) {
                    return [
                        { type: 'UserOrgBUMap', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'UserOrgBUMap', id }))
                    ]
                } else {
                    return [{ type: 'UserOrgBUMap', id: 'LIST' }]
                }
            },
        }),

        createNewUserOrgBUMap: builder.mutation({
            query: (data) => ({
                url: '/userOrgBUMaps/createNewUserOrgBUMap',
                method: 'POST',
                body: { ...data }
            }),
            invalidatesTags: [
                { type: 'UserOrgBUMap', id: 'LIST' },
                { type: 'User', id: 'LIST' }
            ]
        }),

        updateUserOrgBUMap: builder.mutation({
            query: (data) => ({
                url: '/userOrgBUMaps/updateUserOrgBUMap',
                method: 'PATCH',
                body: { ...data }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserOrgBUMap', id: arg.userOrgBUMapId },
                { type: 'UserOrgBUMap', id: 'LIST' },
                { type: 'User', id: 'LIST' }
            ],
        }),

        deleteUserOrgBUMap: builder.mutation({
            query: ({ userOrgBUMapId }) => ({
                url: '/userOrgBUMaps/deleteUserOrgBUMap',
                method: 'DELETE',
                body: { userOrgBUMapId }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'UserOrgBUMap', id: arg.userOrgBUMapId },
                { type: 'UserOrgBUMap', id: 'LIST' },
                { type: 'User', id: 'LIST' }
            ]
        }),

    }),
})

export const {
    useGetUserOrgBUMapsQuery,
    useCreateNewUserOrgBUMapMutation,
    useUpdateUserOrgBUMapMutation,
    useDeleteUserOrgBUMapMutation,
} = userOrgBUMapsApiSlice

export const selectUserOrgBUMapResult =
    userOrgBUMapsApiSlice.endpoints.getUserOrgBUMaps.select()

const selectUserOrgBUMapsData = createSelector(
    selectUserOrgBUMapResult,
    result => result.data
)

export const {
    selectAll: selectAllUserOrgBUMaps,
    selectById: selectUserOrgBUMapById,
    selectIds: selectUserOrgBUMapIds,
} = userOrgBUMapsAdapter.getSelectors(
    state => selectUserOrgBUMapsData(state) ?? initialState
)